import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLiveops } from '@/modules/liveops/item/model/mixins';
import { ROUTE_NAME_LIVEOPS } from '@/modules/liveops/router';
import { liveopsPointService } from '@/services/liveops';
import { onMounted } from 'vue';

export function useLiveopsDetail() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { model, v$, fetch, decorateRewards } = useLiveops();

    const actions = {
        enable: crudAction.confirmAndEnable({
            request: () => liveopsPointService.item.enable(model.id),
            onSuccess: fetch
        }),
        disable: crudAction.confirmAndDisable({
            request: () => liveopsPointService.item.disable(model.id),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: () => liveopsPointService.item.remove(model.id),
            onSuccess: () =>
                router.push({
                    name: ROUTE_NAME_LIVEOPS.ITEM.INDEX(model.rewardType),
                    query: { rewardType: model.rewardType }
                })
        }),
        removeMilestone: crudAction.confirmAndRemove({
            request: (milestoneIndex: number) => liveopsPointService.milestone.remove(model.id, milestoneIndex),
            onSuccess: fetch
        }),
        removeLeaderboard: crudAction.confirmAndRemove({
            request: (toRank: number) => liveopsPointService.milestone.remove(model.id, toRank),
            onSuccess: fetch
        })
    };

    onMounted(async () => {
        await fetch();
        await decorateRewards();
    });

    return { model, v$, actions };
}
